export class ViewerSearch {
  siteType: string;
  townName: string;
  rtn: string;
  address: string;
  regulatoryStatus: string;
  lsp: string;
  siteName: string;
  zipCode: string;
  chemical: string;
}
